import { defineStore } from 'pinia';

export const useMenuStore = defineStore('menu', {
    state: () => ({
        menu: { main: { sections: [] } },
        activeLinkFirstMenu: null,
        activeLinkSecondMenu: null,
        activeSecondMenu: { sections: [] },
        activeThirdMenu: false,
        activePath: null,
    }),

    getters: {
        menuItems: (state) => state.menu?.main?.sections ?? [],

        activeSecondMenuItems: (state) =>
            state.activeSecondMenu?.sections ?? [],

        secondMenuItems: (state) => (codeSecondMenu) =>
            state.menu?.main?.sections.find(
                (item) => item.code === codeSecondMenu
            )?.sections ?? [],

        thirdMenuItems: (state) => (codeThirdMenu) =>
            state.activeSecondMenu?.sections.find(
                (item) => item.code === codeThirdMenu
            )?.sections ?? [],
    },

    actions: {
        updateMenu(items) {
            this.menu = items;
            this.activePath = window.location.pathname;

            let selectedItem = this.menu.main.sections.find(
                (item) => item.selected === 'Y'
            );

            if (!selectedItem && this.activePath === '/') {
                selectedItem = this.menu.main.sections.find(
                    (item) => item.code === 'd1-land'
                );
            }

            if (selectedItem) {
                if (this.activePath !== '/') {
                    this.activeLinkFirstMenu = selectedItem.code;
                }
                this.updateSecondMenu(selectedItem);
            }
        },

        updateSecondMenu(item) {
            // Если тот же элемент или null, сбрасываем меню
            const isMobileFirstPage =
                window.innerWidth < 1180 && this.activePath === '/';

            if (this.activeSecondMenu === item || !item) {
                if (!isMobileFirstPage) {
                    this.resetSecondMenu();
                }
                return;
            }

            this.activeSecondMenu = item;
            if (this.activePath !== '/') {
                this.activeLinkFirstMenu = item.code;
            }

            if (Object.hasOwn(this.activeSecondMenu, 'sections')) {
                const selectedSubItem = this.activeSecondMenu.sections.find(
                    (el) => el.selected === 'Y'
                );
                this.activeLinkSecondMenu = selectedSubItem?.code ?? null;
            }
        },

        resetSecondMenu() {
            this.activeSecondMenu = { sections: [] };
            this.activeLinkSecondMenu = null;
        },

        updateSecondActiveLink(code) {
            this.activeLinkSecondMenu = code;
        },
    },
});
